import {
  createContext,
  useContext,
  type Dispatch,
  type SetStateAction,
} from "react";

export const SIDEBAR_WIDTH_XL_EXPANDED = 300;
export const SIDEBAR_WIDTH_XL_COLLAPSED = 88;

export type SidebarContextValue = {
  toggleSidebar: boolean;
  setToggleSidebar: Dispatch<SetStateAction<boolean>>;
  sidebarCollapsed: boolean;
  setSidebarCollapsed: Dispatch<SetStateAction<boolean>>;
};

const noop = () => {};

const defaultValue: SidebarContextValue = {
  toggleSidebar: false,
  setToggleSidebar: noop,
  sidebarCollapsed: false,
  setSidebarCollapsed: noop,
};

export const SidebarContext =
  createContext<SidebarContextValue>(defaultValue);

export function useSidebar(): SidebarContextValue {
  return useContext(SidebarContext);
}
